import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';

import { Component, OnInit, ViewChild, NgZone, HostListener, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, RouterOutlet } from "@angular/router";
import { ApiService } from '../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceInRequiredValidator, password_validation } from '../shared/constants';
import { slideInAnimation } from '../animations/route-animation';
import moment from 'moment';

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrl: './navbar.component.scss',
	animations: [slideInAnimation]
})
export class NavbarComponent implements OnInit, AfterViewChecked {
	title = 'material-responsive-sidenav';
	isCollapsed = true;
	logourl = "../assets/img/cubelogo.png";
	year: number = moment().year();
	resetPasswordForm!: FormGroup;
	user_name = "";
	emailId = "";
	screenHeight = screen.height - 200;
	UserModuleAccess: any = null;
	inventoryDashboardUrl = this.apiService.getDashboardURL("inventory");
	mhsDashboardUrl = this.apiService.getDashboardURL("mhs");
	hcDashboardUrl = this.apiService.getDashboardURL("hc");
	hcNewDashboardUrl = this.apiService.getDashboardURL("hcDash");
	clipDashboardUrl = this.apiService.getDashboardURL("clip");
	rmaMaster = this.apiService.getDashboardURL("rmaMaster");
	pharmaMaster = this.apiService.getDashboardURL("pharmaMaster");
	homeUrl = this.apiService.getHomeURL();
	user_type: any = "";
	company_or_fleet: any = {};
	accessLoader = false;

	constructor(private changeRef: ChangeDetectorRef, private observer: BreakpointObserver, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, private zone: NgZone) {
		this.accessLoader = true;
		this.apiService.getUserAccess().subscribe((data: any) => {
			this.accessLoader = false;
			try {
				this.user_type = data.res[0].user_type;
				this.user_name = data.res[0].FirstName + " " + data.res[0].LastName;
				this.emailId = data.res[0].Email;
				this.UserModuleAccess = JSON.parse(data.res[0].UserModuleAccess);
				if (this.user_type != 'cdm') {
					if (this.user_type == 'company') {
						this.company_or_fleet = data.res[0].company_id[0];
					} else {
						this.company_or_fleet = data.res[0].fleet_id[0];
					}
				}
			} catch (error) { }
		}, (error: any) => {
			this.accessLoader = false;
		});
	}

	ngAfterViewChecked(): void {
		this.changeRef.detectChanges();
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.resetPasswordForm = this.formBuilder.group({
				password: ['', [Validators.required, noWhitespaceInRequiredValidator, password_validation]],
				confirmPassword: ['', [Validators.required, noWhitespaceInRequiredValidator]],
			}, {
				validators: this.passwordMatchValidator.bind(this)
			});
		});

	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
	}

	passwordMatchValidator(formGroup: FormGroup) {
		const password = formGroup.get('password');
		const confirmPassword = formGroup.get('confirmPassword');
		return password!.value === confirmPassword!.value ? null : { passwordNotMatch: true };
	}

	get f() { return this.resetPasswordForm.controls; }

	resetPasswordModal() {
		$("#changePasswordModal").modal("show");
	}

	resetPassword() {
		if (this.resetPasswordForm.invalid) {
			return;
		}
		let data = {
			username: this.emailId,
			password: this.f.password.value
		}
		this.apiService.resetPassword(data).subscribe(data => {
			this.clearResetPassword();
			this.toastr.info("Password changed successfully.", 'Success!!!', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			this.logoutUser();
		}, (error) => {
			if (error.status == 401) { return }
			this.toastr.error("Error while changing password.", 'Error!', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		});
	}

	clearResetPassword() {
		$("#changePasswordModal").modal("hide");
		this.f.password.setValue("");
		this.f.confirmPassword.setValue("");
		this.f.password.updateValueAndValidity();
		this.f.confirmPassword.updateValueAndValidity();
		this.resetPasswordForm.markAsUntouched();
		this.resetPasswordForm.reset();
	}

	logoutUser() {
		this.apiService.logout().subscribe(data => {
			this.apiService.navigateToLogin(false);
		}, (error) => {
			this.apiService.navigateToLogin(false);
		});
	}

	invoiceLinkClicked() {
		let data: any = {}
		this.apiService.invoiceMenuAlert(data).subscribe({ next: data => { }, error: (error) => { } });
	}

	scrollToTop() {
		let selector = "#page-content-container-common";
		try {
			$('html, body').animate({
				scrollTop: $(selector).offset().top + 'px'
			}, 'slow');
		} catch (error) { }
	}

	showScrollBtn = false;
	@HostListener('window:scroll', ['$event'])
	onScroll(e: any) {
		try {
			if ($('#main-menu-header').offset().top) {
				this.showScrollBtn = true;
			} else {
				this.showScrollBtn = false;
			}
		} catch (error) { }
	}
}
